
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minu/seaded/profiil/DAC7",
      function () {
        return require("private-next-pages/minu/seaded/profiil/DAC7/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minu/seaded/profiil/DAC7"])
      });
    }
  